import { ca } from '@cian/analytics';

import { type IBank } from '../../types/bank';
import { getProductsData } from '../../utils/getProductsData';

export function trackAccreditedBanksToListingClick(bank: IBank): void {
  ca('eventSite', {
    action: 'click_accredited_banks',
    category: 'Promo',
    label: 'to_listingjk',
    name: 'oldevent',
    products: [getProductsData({ bank_name: bank.name, bankId: bank.id })],
  });
}
